<template>
  <v-layout
    row
    wrap>
    <v-flex
      xs12
    >
      <v-text-field
        :value="password"
        :error-messages="errorMessages"
        :rules="[$rules.isRequired, $rules.isValidPassword]"
        :append-icon="showPassword ? 'visibility_off' : 'visibility'"
        :type="showPassword ? 'text' : 'password'"
        :required="true"
        :label="$t('label')"
        name="password-input"
        @input="val => $emit('changed', val)"
        @click:append="showPassword = !showPassword"
      />
    </v-flex>
    <v-flex
      xs12
    >
      <v-text-field
        :value="password_confirmation"
        :error-messages="errorMessages"
        :rules="[$rules.isRequired, $rules.isPasswordMatch([password, password_confirmation])]"
        :append-icon="showPasswordConfirm ? 'visibility_off' : 'visibility'"
        :type="showPasswordConfirm ? 'text' : 'password'"
        :required="true"
        :label="$t('labelConfirm')"
        @input="val => $emit('changedConfirm', val)"
        @keydown.enter="$emit('submit')"
        @click:append="showPasswordConfirm = !showPasswordConfirm"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'PasswordPair',
  props: ['errorMessages', 'password', 'password_confirmation'],
  data () {
    return {
      showPasswordConfirm: false,
      showPassword: false
    }
  },
  i18n: {
    messages: {
      en: {
        label: 'Password',
        labelConfirm: 'Confirm password',
        passwordMin8Chars: 'Min. 8 chars',
        passwordNotMatching: 'Passwords not equal'
      },
      tr: {
        label: 'Şifre',
        labelConfirm: 'Şifreyi onaylayınız',
        passwordMin8Chars: 'Minimum 8 karakter',
        passwordNotMatching: 'Şifreler uyuşmuyor'
      },
      de: {
        label: 'Passwort',
        labelConfirm: 'Passwort wiederholen',
        passwordMin8Chars: 'Mindestens 8 Zeichen',
        passwordNotMatching: 'Passwörter nicht gleich'
      },
      ru: {
        label: 'Пароль',
        labelConfirm: 'Подтвердите пароль',
        passwordMin8Chars: 'Минимум 8 символов',
        passwordNotMatching: 'Пароли не равны'
      }
    }
  }
}
</script>
